module.exports = __webpack_public_path__ + "img/double-back.c230005a.svg";